import React, { useState, createRef } from "react";

import { getCsrfCookieName } from "js/helpers/gazetteGetCsrfCookieName";
import { getCookie } from "js/helpers/gazetteGetCookie";
import { convertPxToRem } from "frontend/components/helpers";

import colors from "core/colors";
import {
    NewsletterSubscription,
    NewsletterSubscriptionForm,
    NewsletterSubscriptionHeading,
    NewsletterSubscriptionSubmitBtn,
    NewsletterSubscriptionSuccessMessage
} from "./styles";

import Success from "core/ReusableIcons/Success";
import FormInput from "core/FormInput";

export const NounGazetteSubscription = () => {
    const [inputValue, setInputValue] = useState("");

    const [subscriptionSuccessful, setSubscriptionSuccessful] = useState(false);
    const [requestSent, setRequestSent] = useState(false);

    const formRef = createRef();

    const sendRequest = async () => {
        const csrfCookieName = getCsrfCookieName();
        const csrftoken = getCookie({ name: csrfCookieName });

        let response = await fetch("/mailing-list/subscribe/", {
            method: "POST",
            headers: { "X-CSRFToken": csrftoken },
            // FormData object structure required by server
            // FormData needs reference to form element
            body: new FormData(formRef.current)
        });

        response = await response.json();
        return response;
    };

    const handleSubmit = async e => {
        e.preventDefault();

        const response = await sendRequest();
        setRequestSent(true);

        setSubscriptionSuccessful(response.success);
    };

    const successMessage = (
        <NewsletterSubscriptionSuccessMessage
            icon={Success}
            accentColor={colors.alternative.lightMode.chartreuse}
        >
            Thanks for subscribing!
        </NewsletterSubscriptionSuccessMessage>
    );

    const form = (
        <NewsletterSubscriptionForm ref={formRef} onSubmit={handleSubmit}>
            <FormInput
                onChange={setInputValue}
                value={inputValue}
                aria-label="Email address"
                type="email"
                placeholderText="Enter your email"
                labelText="Enter your email"
                width={convertPxToRem({ px: 214 })}
                darkMode
                name="email"
                required
            />
            <NewsletterSubscriptionSubmitBtn type="submit">
                Submit
            </NewsletterSubscriptionSubmitBtn>
        </NewsletterSubscriptionForm>
    );

    return (
        <NewsletterSubscription>
            <NewsletterSubscriptionHeading>
                Subscribe to Noun Gazette
            </NewsletterSubscriptionHeading>
            {requestSent && subscriptionSuccessful ? successMessage : form}
        </NewsletterSubscription>
    );
};
